import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from './fixed-data-picker/FixedDataPicker';
import { IPickerProps } from './types';

export enum TicketPriority {
  HIGH = 1,
  NORMAL = 0,
  LOW = -1,
}

export type PriorityEntityLike = {
  id: number;
  name: string;
};

export const usePriority = (): PriorityEntityLike[] => {
  const { t } = useTranslation();
  const dataSet = useMemo(() => {
    return [
      {
        id: TicketPriority.LOW,
        name: t(`COMMON.LOW`),
      },
      {
        id: TicketPriority.NORMAL,
        name: t(`COMMON.NORMAL`),
      },
      {
        id: TicketPriority.HIGH,
        name: t(`COMMON.HIGH`),
      },
    ];
  }, [t]);

  return dataSet;
};

export type IPriorityEntityLikePickerProps<TMultiple extends boolean> =
  IPickerProps<PriorityEntityLike, TMultiple>;

export function PriorityEntityLikePicker<TMultiple extends boolean>(
  props: IPriorityEntityLikePickerProps<TMultiple>
) {
  const { ...rest } = props;

  const dataSet = usePriority();

  return <FixedDataPicker dataSet={dataSet} {...rest} />;
}
